import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgComponent } from './svg.component';
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SvgComponent
  ]
})
export class SvgModule { }
